import React, { useEffect, useState } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { Container, Header, Heading, Content } from "../Summarize/Style";
import { Iframe } from "../Iframe/Style";
import BackIcon from "../../assets/back-icon.svg";
import { useTranslation } from "react-i18next";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";


export default function Todo() {
  const { t, i18n } = useTranslation();

  const user_id = localStorage.getItem("id");
  const email = localStorage.getItem("email");
  const isTodoOnboarded = localStorage.getItem("isTodoOnboarded");

  const [iframeSrc, setIframeSrc] = useState(
    `https://todo.aivoria.nl/?user_id=${user_id}&email=${email}&isTodoOnboarded=${isTodoOnboarded}&lang=${i18n.language}`
  );

  useEffect(() => {
    setIframeSrc(
      `https://todo.aivoria.nl/?user_id=${user_id}&email=${email}&isTodoOnboarded=${isTodoOnboarded}&lang=${i18n.language}`
    );
  }, [i18n.language, user_id, email, isTodoOnboarded]);


  const { isSidebarOpen } = useOutletContext();
  const navigate = useNavigate();

  return (
    <Container isOpen={isSidebarOpen} style={{ marginRight: "1.4rem" }}>
      <Header style={{ alignItems: "center", justifyContent: "space-between" }}>
        <div
          style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}
          onClick={() => navigate("/")}
        >
          <img src={BackIcon} alt={t("todo.back")} />

          <Heading style={{ marginBottom: 0 }}>
            {t("todo.title")}
          </Heading>

          <Tooltip
            title={t("todo.tooltip")}
            placement="top"
          >
            <InfoCircleOutlined
              style={{
                fontSize: 14,
                color: "#8c8c8c",
                cursor: "pointer",
              }}
              onClick={(e) => e.stopPropagation()} // prevent navigation
            />
          </Tooltip>
        </div>
      </Header>

      <Content>
        <Iframe src={iframeSrc} />
      </Content>
    </Container>
  );
}
